import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

import type { TierInfo } from './useTier';

interface DashboardData {
  partner: {
    id: string;
    name: string;
    tier: string;
    vertical: string;
  };
  tierInfo: TierInfo;
  kpis: {
    impressions: number;
    impressionsGuarantee: number;
    clicks: number;
    ctr: number;
    leads: number;
    roi: number | null;
    totalInvested: number;
    totalInfluenced: number;
    budgetUsed: number;
    budgetTotal: number;
  };
  chartData: { date: string; impressions: number }[];
  activeCampaigns: {
    id: string;
    name: string;
    category: string;
    regions: string[] | null;
    active: boolean;
    impressions: number;
    clicks: number;
    ctr: number;
  }[];
}

function getCurrentMonth(): string {
  const now = new Date();
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, '0');
  return `${y}-${m}`;
}

export function useDashboard(month?: string | null) {
  const selectedMonth = month ?? getCurrentMonth();
  const enabled = month !== null;

  return useQuery<DashboardData>({
    queryKey: ['partner-dashboard', selectedMonth],
    queryFn: async () => {
      const res = await api.get('/partners/my/dashboard', {
        params: { month: selectedMonth },
      });
      return res.data;
    },
    enabled,
    refetchInterval: enabled ? 60_000 : false,
  });
}
